import api from "./api";

const videoRoomService = {};
const endpoint = `/video-room`;

videoRoomService.createRoom = function ({ patientId, appointmentId }) {
  return api
    .post(endpoint, { patientId, appointmentId })
    .then((res) => res.data);
};

videoRoomService.getRoomAccessToken = function (roomId) {
  return api
    .get(`${endpoint}/access-token/${roomId}`)
    .then((res) => res.data.accessToken);
};

/**
 * @description Obtiene la sala activa para un turno, sin autenticación (acceso de paciente).
 * @param {string} appointmentId - ID del turno
 * @param {string} patientId - ID del paciente (reemplaza auth)
 * @returns {Promise<Object>} Datos de la sala de video
 */
videoRoomService.getRoomByAppointment = function (appointmentId, patientId) {
  return api
    .get(`${endpoint}/active-room/${appointmentId}`, { params: { patientId } })
    .then((res) => res.data);
};

/**
 * @description Obtiene un token de acceso para paciente sin autenticación.
 * @param {string} roomId - ID de la sala
 * @param {string} patientId - ID del paciente (reemplaza auth)
 * @returns {Promise<string>} Access token de Twilio
 */
videoRoomService.getPatientRoomAccessToken = function (roomId, patientId) {
  return api
    .get(`${endpoint}/access-token/${roomId}`, { params: { patientId } })
    .then((res) => res.data.accessToken);
};

videoRoomService.getRoomInfo = function (roomId) {
  return api.get(`${endpoint}/${roomId}`).then((res) => res.data);
};

videoRoomService.startRoom = function (roomId) {
  return api.put(`${endpoint}/start-room/${roomId}`).then((res) => res.data);
};

videoRoomService.endRoom = function (roomId) {
  return api.put(`${endpoint}/end-room/${roomId}`).then((res) => res.data);
};

export default videoRoomService;
